import React from "react";
import "./Hero.css";
import UpcomingEvents from "../UpcomingEvents/UpcomingEvents";

function Hero() {
  return (
    <section className="hero">
      <div className="hero-left">
        <h1 className="hero-title">VfB Johannesberg 1984 e.V</h1>
        <h3 className="hero-subtitle">
          Sport, Gemeinschaft & Leidenschaft seit 1984
        </h3>
        <a href="#about" className="hero-button">
          Mehr erfahren
        </a>
      </div>
      <div className="hero-right">
        <UpcomingEvents />
      </div>

      {/* --- NEW SCROLL PROMPT --- */}
      <a href="#about" className="scroll-down-prompt" aria-label="Scroll down">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="scroll-down-icon"
        >
          <polyline points="7 13 12 18 17 13"></polyline>
          <polyline points="7 6 12 11 17 6"></polyline>
        </svg>
      </a>
      {/* --- END NEW SCROLL PROMPT --- */}
    </section>
  );
}

export default Hero;